import React from "react";
import web from "../images/services/web.svg"; 
import app from "../images/services/mobile.svg"; 
import soft from "../images/services/soft.svg"; 
import cloud from "../images/services/cloud.svg"; 
import marketing from "../images/services/marketing.svg"; 
import ecommerce from "../images/services/e-commerce.svg";
import product from "../images/services/product.svg";
import security from "../images/services/security.svg";
import ideas from "../images/services/ideas.svg";
import graphic from "../images/services/graphic.svg";
import seo from "../images/services/seo.svg";
import contentmarket from "../images/services/contentmarket.svg";

const Data = [

	{
		scardimage: web,
		scardtitle : "Web Development",
		scarddesc: "Crafting Digital Experiences, One Code at a Time. Byteskull Technologies: Building the Web of Possibilities.",
	},
	{
		scardimage: app,
		scardtitle : "App Development",
		scarddesc: "Building innovative mobile and web applications for diverse needs.",
	},
	{
		scardimage: soft,
		scardtitle : "Software Development",
		scarddesc: "Turning Visions into Functionalities, Byteskull Technologies: Where Ideas Evolve into Software Solutions.",
	},
	{
		scardimage: cloud,
		scardtitle : "Cloud Services",
		scarddesc: "Sky's No Limit with Byteskull Cloud Services. Elevate Your Business Beyond Horizons.",
	},
	{
		scardimage: graphic,
		scardtitle : "Graphic Designing",
		scarddesc: "Elevating Ideas, Crafting Visual Stories. Byteskull Technologies: Where Design Meets Imagination for Captivating Visual Experiences.",
	},
	{
		scardimage: marketing,
		scardtitle : "Digital Marketing",
		scarddesc: "Amplifying Your Digital Presence, Connecting Success Dots. Byteskull Technologies: Navigating Your Brand's Journey in the Digital Realm.",
	},
	{
		scardimage: seo,
		scardtitle : "SEO",
		scarddesc: "Optimizing your online presence for better visibility and reach.",
	},
	{
		scardimage: contentmarket,
		scardtitle : "Content Marketing",
		scarddesc: "Developing and promoting strategic content to engage and inform.",
	},
	{
		scardimage: ideas,
		scardtitle : "Ideas into business",
		scarddesc: "From Idea to Impact: Where Innovation Ignites Entrepreneurship. Let Your Vision Soar with Us at Byteskull Technologies.",
	},
	{
		scardimage: product,
		scardtitle : "Product Building",
		scarddesc: "From Concept to Reality, Byteskull Technologies Builds Your Vision. Crafting Products that Redefine Innovation and Shape Industries.",
	},
	{
		scardimage: security,
		scardtitle : "Data Security",
		scarddesc: "Guardians of Your Digital Trust: Byteskull Technologies. Where Data Security is Fortified, and Your Peace of Mind is our Priority.",
	},
	{
		scardimage: ecommerce,
		scardtitle : "Building e-commerce",
		scarddesc: "Empowering Your Online Ambitions, One Click at a Time. Byteskull Technologies: Building E-commerce Solutions that Redefine Retail in the Digital Age.",
	},

];

export default Data;